import React from "react";
import { Modal } from "react-bootstrap";
import { Radio } from "@rmwc/radio";
import { connect, useDispatch, useSelector } from "react-redux";
import {   CheckOtherBuildingType } from "../../../action";
import { buildingStyleChangeAccordingtoType } from "../../../action/building/building_style/buildingStyle.action";
import { buildingStyleChange } from "../../../action/building/building_style/buildingStyle.action";
const BuildingTypeOption = ({ val, checkedBuildingType, ExtraBuildingID, defaultBuilding }) => {
  const dispatch = useDispatch();
  return (
    <aside className={checkedBuildingType == parseInt(val) ? "psf-section active" : "psf-section"}>
      <Radio
        label={ExtraBuildingID[val].name}
        value={val}
        name="twentypfscarports"
        checked={checkedBuildingType == parseInt(val) ? true : false}
        onChange={(e) => {
          dispatch(CheckOtherBuildingType(e.target.value, defaultBuilding));
        }}
      />
    </aside>
  );
};

const BuildingType = () => {
  const dispatch = useDispatch();
  const { const_var, defaultBuilding, checkedBuildingType } = useSelector(state => state.reducer);
  let style;
  if (window.screen.availWidth < 500) {
    style = { padding: "40px 20px" };
  }

  let parseVal = parseInt(defaultBuilding);
  let chkVariable = parseInt(defaultBuilding);
  if (defaultBuilding != undefined) {
    let filterRecord = const_var.defaultBuildingArr.filter((data) => data.building_id == checkedBuildingType && const_var.defaultBuildingArr[parseVal]?.image_name == data?.image_name);
    if (filterRecord.length > 0) {
      chkVariable = filterRecord[0].building_id;
    }
  }
  let textVar = "These buildings differ by Snowload/Windload ratings but provide you all the features to customize";
  return (
    <div>
      <Modal centered show={const_var.isShowbuildingtype} backdrop="static" keyboard={false} dialogClassName="alert-modal react-modal building-select-modal" backdropClassName="ract-modal-pre-parent">
        <button
          className="close"
          onClick={() => {
            dispatch(buildingStyleChangeAccordingtoType());
          }}
        >
          <span className="icon-close"></span>
        </button>

        <Modal.Body className="" style={style}>
          <h5 className="modal-title text-uppercase mb-1">Choose from the below Building Types</h5>

          <p className="mb-2 mt-2">{textVar}</p>

          <div className="building-type-radio radioinput d-flex flex-wrap">
            {const_var.isShowbuildingtypeArr.map((val, index) => {
              return (
                <BuildingTypeOption
                  key={index}
                  val={val}
                  checkedBuildingType={checkedBuildingType}
                  ExtraBuildingID={const_var.ExtraBuildingID}
                  defaultBuilding={defaultBuilding}
                />
              );
            })}

            <aside className="text-center mt-4">
              <button
                className="pushable pushable-with-left-right pushable-dark"
                onClick={() => {
                  dispatch(buildingStyleChange(chkVariable, ""));
                }}
              >
                <span className="edge"></span>
                <div className="front">
                  <div className="front-left">
                    <span className="text">CONFIRM</span>
                  </div>
                  <div className="front-right">
                    <span className="icon icon-arrow-double-small"></span>
                  </div>
                </div>
              </button>
            </aside>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BuildingType;






// import React, { Component } from 'react';
// import {Modal, Button,Tabs,Tab,ButtonToolbar,OverlayTrigger,Tooltip} from 'react-bootstrap';
// import Scrollbar from 'react-scrollbars-custom';
// import { Radio } from '@rmwc/radio';
// import {connect} from 'react-redux';
// import * as actionCreator from "../../../action/index.js"
// class BuildingType extends React.Component {

// render() {
//   let style;

//   if (window.screen.availWidth < 500) {
//     style = {'padding': '40px 20px'};
//   }

//   let parseVal = parseInt(this.props.defaultBuilding);
//   let chkVariable = parseInt(this.props.defaultBuilding);
//   if(this.props.defaultBuilding!=undefined)
//   {
//     // console.log(this.props.const_var.defaultBuildingArr,this.props.defaultBuilding,parseVal,this.props.checkedBuildingType,"this.props.const_var.defaultBuildingArr")
//     let filterRecord = this.props.const_var.defaultBuildingArr.filter(data=>data.building_id==this.props.checkedBuildingType && this.props.const_var.defaultBuildingArr[parseVal]?.image_name==data?.image_name);
//     if (filterRecord.length>0) {
//       chkVariable = filterRecord[0].building_id;
//     }
//   }
//   //console.log(this.props.const_var.isShowbuildingtypeArr,parseVal,this.props.checkedBuildingType,this.props.defaultBuilding,this.props.const_var.defaultBuildingArr,'chkVariable1111',filterRecord,chkVariable)
//   let textVar = "These buildings differ by Snowload/Windload ratings but provide you all the features to customize";
//     return (
//        <div>
//            <Modal centered show={this.props.const_var.isShowbuildingtype /*&& window.innerWidth < 993*/ } backdrop='static' keyboard={false} dialogClassName= "alert-modal react-modal building-select-modal"  backdropClassName="ract-modal-pre-parent " >

//             <button className="close" onClick={() =>{this.props.buildingStyleChangeAccordingtoType();}}><span className="icon-close"></span></button>
//             <Modal.Body className="" style={style}>
//             <h5 className="modal-title text-uppercase mb-1">Choose from the below Building Types</h5>
//             <p className="mb-2 mt-2">{textVar}</p>
//             <div className="building-type-radio radioinput d-flex flex-wrap">
//               {this.props.const_var.isShowbuildingtypeArr.map((val, index) => {
//                 return (
//             // <aside className={this.props.const_var.defaultBuildingArr.length>0 && isNaN(parseVal)==false && this.props.const_var.defaultBuildingArr[chkVariable].building_id==val ? 'psf-section active' :'psf-section' }>
//             <aside className={this.props.checkedBuildingType==parseInt(val) ? 'psf-section active' :'psf-section' }>
//                <Radio
//                   label={this.props.const_var.ExtraBuildingID[val].name}
//                   value={val}
//                   name="twentypfscarports"
//                   checked={(this.props.checkedBuildingType==parseInt(val))?true:false}
//                   onChange={e => {this.props.CheckOtherBuildingType(e.target.value,this.props.defaultBuilding)}}
//                   >
//                </Radio>
//             </aside>

//             )
//             })
//               }

//              <aside className="text-center mt-4">

//              <button  className="pushable pushable-with-left-right pushable-dark" onClick={() =>{this.props.buildingStyleChange(chkVariable,"");}}>
//                      <span className="edge"></span>
//                      <div className="front">
//                      <div className="front-left">
//                         <span className="text">CONFIRM</span>

//                      </div>
//                      <div className="front-right">
//                         <span className="icon icon-arrow-double-small"></span>
//                      </div>
//                      </div>
//                      </button>

//              </aside>

//             </div>

//           </Modal.Body>

//         </Modal>
//         </div>
//     )
//   }
// }

// const mapStoreToProps = (state) => {
//   return state.reducer
// }

// export default connect(
//   mapStoreToProps,
//   actionCreator
// )(BuildingType);